import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollService {

  constructor() { }

  /**
   * Scroll to top of the page with smooth animation
   */
  scrollToTop(): void {
    // Try to find the actual scrollable container
    const mainContainer = document.getElementById('mainDIV');
    const htmlElement = document.documentElement;
    const bodyElement = document.body;
    
    // Try to scroll the element that actually has scroll content
    if (mainContainer && mainContainer.scrollTop > 0) {
      mainContainer.scrollTop = 0;
    } else if (htmlElement.scrollTop > 0) {
      htmlElement.scrollTop = 0;
    } else if (bodyElement.scrollTop > 0) {
      bodyElement.scrollTop = 0;
    } else if (window.pageYOffset > 0) {
      window.scrollTo(0, 0);
    } else {
      // Try all methods as fallback
      if (mainContainer) mainContainer.scrollTop = 0;
      htmlElement.scrollTop = 0;
      bodyElement.scrollTop = 0;
      window.scrollTo(0, 0);
    }
  }

  /**
   * Scroll to top of the page instantly (no animation)
   */
  scrollToTopInstant(): void {
    window.scrollTo(0, 0);
  }

  /**
   * Scroll to a specific element by ID
   */
  scrollToElement(elementId: string, offset: number = 0): void {
    const element = document.getElementById(elementId);
    if (element) {
      const elementPosition = element.offsetTop - offset;
      window.scrollTo({ top: elementPosition, behavior: 'smooth' });
    }
  }

  /**
   * Scroll to a specific element by class
   */
  scrollToElementByClass(className: string, offset: number = 0): void {
    const element = document.querySelector(`.${className}`);
    if (element) {
      const elementPosition = (element as HTMLElement).offsetTop - offset;
      window.scrollTo({ top: elementPosition, behavior: 'smooth' });
    }
  }

  /**
   * Get current scroll position
   */
  getScrollPosition(): number {
    const mainContainer = document.getElementById('mainDIV');
    if (mainContainer) {
      return mainContainer.scrollTop || 0;
    }
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  /**
   * Check if user has scrolled down
   */
  hasScrolled(): boolean {
    return this.getScrollPosition() > 100;
  }
} 